module.exports = __webpack_public_path__ + "prod/20260903163609/img/service.f8729c23.png";